import styled from 'styled-components';

interface DividerProps {
  height?: number;
  width?: number;
}

export const Divider = styled.div<DividerProps>`
  ${({ height }) => (height ? `height: ${height}px;` : '')}
  ${({ width }) => (width ? `width: ${width}px;` : '')}
`;
